import React from "react";
import { Dropdown } from "react-bootstrap";
import "./breadcrumb.css";
import { Link } from "react-router-dom";
import DataLastUpdated from "./DataLastUpdated";

function CustomBreadcrumb({ items }) {
  var iterationLevel = 0;

  function checkStatus(json) {
    return json.some(item => item.status === true);
  }
  function getChildData(item, index) {
    return (
      <>
        <div className="d-flex" key={index}>
          {item.hasOwnProperty("href") ? (
            <Link to={item.href}>
              <div className="breadcrumbItem">{item.label}</div>
            </Link>
          ) : (
            <div className="breadcrumbItem">{item.label}</div>
          )}
        </div>
        {item.pages && item.pages.length > 0 && checkStatus(item.pages) ? (
          <>
            <Dropdown size="sm" className="breadcrumbDropdownWrapper">
              <Dropdown.Toggle
                className="breadcrumbItem seperator mx-1 position-relative"
                variant="info"
                id="dropdown-basic"
              >
                &gt;
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {item.pages.map((page, pageIndex) => (
                  <>
                    <Dropdown.Item href={page?.href}>
                      {page.label}
                    </Dropdown.Item>
                  </>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <div className="d-none">{(iterationLevel = ++iterationLevel)}</div>
            {
              item.pages.map((page, pageIndex) => (
                <>{page.status ? getChildData(page) : ""}</>
              ))}
          </>
        ) : (
          ""
        )}
      </>
    );
  }
  return (
    <div className="d-flex mb-2 pb-2 gap-3">
      {/* <div className="d-flex">{items.map((item, index) => (
        <>{getChildData(item, index)}</>
      ))} </div> */}
      <DataLastUpdated />
    </div>
  );
}
export default CustomBreadcrumb;
